<template>
    <div class="main">
        <ul class="content">
            <li v-for="item in figmaList" :key="item.id"  @click="showMask">
                <img :src="item.imgSrc" alt="">
                <span>
                    {{item.title}}
                </span>
                <span>{{item.price}}</span>
            </li>
        </ul>
        <common-mask v-if="isMask" @closeMask="closeMask"></common-mask>
    </div>
</template>
<script>
import ComtentA from '@/components/useQuestion'
import ComtentB from '@/components/engineering'
import ComtentC from '@/components/sapplication'
import CommonMask from '@/components/mask'
export default {
    name:'figma',
    data() {
        return {
            isMask:false,
            content: '',
            select: '1',
            figmaList:[
                {
                    id:'01',
                    imgSrc: require("../../static/img/figma/u154.png"),
                    title:'Max Factory figma 只狼·影逝二度附特典手辦模型',
                    price:'$120.99'
                },
                {
                    id:'02',
                    imgSrc: require("../../static/img/figma/u155.png"),
                    title:'特價 figma 178 刀劍神域 亞絲娜 手辦 現貨',
                    price:'$99.99'
                },
                {
                    id:'03',
                    imgSrc: require("../../static/img/figma/u156.png"),
                    title:'現貨正版 figma 354 刀劍神域 SAO 桐人 O.S 大劍 可動手辦',
                    price:'$99.99'
                },
                {
                    id:'04',
                    imgSrc: require("../../static/img/figma/u157.png"),
                    title:'特價 figma 加速世界 黑雪姬 戰鬥手辦 sp044 現貨',
                    price:'$99.99'
                },
                {
                    id:'05',
                    imgSrc: require("../../static/img/figma/u158.png"),
                    title:'Hobby通販 Max Fate FGO 宮本武藏 figma 可動手辦現貨',
                    price:'$66.99'
                },
                {
                    id:'06',
                    imgSrc: require("../../static/img/figma/u159.png"),
                    title:'日版MaxFactory figma 孤獨的美食家 井之頭五郎 松重丰 手辦現貨',
                    price:'$66.99'
                },
                 {
                    id:'07',
                    imgSrc: require("../../static/img/figma/u160.png"),
                    title:'現貨正版 figma 248 刀劍神域 SAO 桐人 桐子 可動手辦',
                    price:'$66.99'
                },
                {
                    id:'08',
                    imgSrc: require("../../static/img/figma/u161.png"),
                    title:'MF日版figma⭐K-ON輕音少女天井中律制服正版可動手辦Max Factory',
                    price:'$61.99'
                },
                {
                    id:'09',
                    imgSrc: require("../../static/img/figma/u162.png"),
                    title:'全新日版現貨 MF figma 222 赤城 艦隊collection 手辦 可動',
                    price:'$70.99'
                },
                {
                    id:'10',
                    imgSrc: require("../../static/img/figma/u163.png"),
                    title:'進擊的巨人figma203三笠207艾倫213利威爾兵長可動公仔手辦模型',
                    price:'$99.99'
                },
                {
                    id:'11',
                    imgSrc: require("../../static/img/figma/u164.png"),
                    title:'[現貨]MaxFactory figma只狼:DX Edition影逝二度豪華版手辦模型',
                    price:'$120.99'
                },
                {
                    id:'12',
                    imgSrc: require("../../static/img/figma/u165.png"),
                    title:'正版 黑岩射手 The Game figma 116 BRS2035 正版手辦 wrs 白岩',
                    price:'$79.99'
                },
            ]
        }
    },
    components: { ComtentA, ComtentB, ComtentC, CommonMask },
    mounted: function () {},
    methods: {
        selectComponents: function (e) {
            this.select = e
        },
        showMask() {
            this.isMask = true;
        },
        closeMask() {
            this.isMask = false;
        }
    },
    computed: {},
}
</script>
<style lang="css" scoped>
.main {
    width: 100%;
    position: relative;
    top: 0;
    padding-top: 150px;
    background-color: #f3f4f2;
}
.toptab {
    width: 900px;
    margin: 0 auto;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-start;
}
.toptab .active {
    border: 1px solid #ef653d;
}
.tabBtn {
    color: #ef653d;
    font-size: 20px;
    font-weight: 600;
    margin-right: 50px;
    padding: 5px 8px;
    box-sizing: border-box;
    border-radius: 10px;
    cursor: pointer;
}
.component-fade-enter-active,
.component-fade-leave-active {
    transition: opacity 0.3s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active for below version 2.1.8 */ {
    opacity: 0;
}
.main ul {
    list-style: none;
    width: 1200px;
    margin: 0 auto;
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    /**background: pink;**/
}
.main ul li{
    width: 249px;
    height: 350px;
    margin-bottom: 45px;
    overflow: hidden;
    font-size: 14px;
    border:1px solid #d7d7d7;
    cursor: pointer;
}
.main ul li:hover{
    box-shadow:0 0 12px 0 rgba(50,50,50,.2);
}
.main ul li:hover img{
    transform: scale(1.08);
}
.main ul li:hover span{
    color:#ef653d
}
.main ul li img{
    width: 249px;
    height: 249px;
    transition: all .9s;
}
.main ul li span{
    display: block;
}
.main ul li span:nth-of-type(1){
    display: block;
    margin:18px 0 10px;
}
.main ul li span:nth-of-type(2){
    display: block;
    color:#ef653d;
    /* color:#f08200; */
    font-size: 22px;
}
</style>



// WEBPACK FOOTER //
// src/components/figma.vue